<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.app')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="text-right">
        <p class="d-inline-flex">
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.saveChanges')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <form>
      <div class="card mar-to-15" style="display:none;"> <!-- just for devs -->
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{$t('settingCompany.selfOrderDomain')}}</label>
                <input type="text" name="appLink" :placeholder="$t('settingCompany.selfOrderDomain')" v-model="model.self_order_domain" class="form-control">
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Kiosk/Table Colors</label>
                <input type="text" name="appLink" :placeholder="$t('settingCompany.selfOrderDomain')" v-model="model.table_colors" class="form-control">
                <span>{"sideBarBg": "#fff", "mainPageBg": "#F1F1F1", "addBtnColor": "#ffca40", "addBtnColorInv": "#000", "iconsColor1": "#942007", "iconsColor2": "#fff", "secundarColor": "#ffca40", "principalColor": "#4D966D"}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Imagine bg transparent Kiosk</label>
                <!-- :file-list="[{'url': model.kiosk_transparent_bg}]" -->
                <el-upload
                  action=""
                  ref="upload"
                  :limit="2"
                  :file-list="model.kiosk_transparent_bg ? model.kiosk_transparent_bg : []"
                  list-type="picture-card"
                  accept=".jpg, .jpeg, .png"
                  :on-change="(file,fileList) =>{return handleImgChnage(file,fileList,index)}"
                  :on-exceed="handleExceed"
                  :on-remove="(file,fileList) =>{return handleRemove(file,fileList,index)}"
                  :auto-upload="false">
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                </el-upload>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <br>
                <button class="btn btn-info mar-rt-10" @click="deleteCacheFromKiosk()">Delete Cache For Kiosks</button>
                <button class="btn btn-info mar-rt-10" @click="restartAllKiosk()">Restart all Kiosks</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{$t('settingCompany.appLink')}}</label>
                <input type="text" name="appLink" :placeholder="$t('settingCompany.appLink')" v-model="model.app_link" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('settingCompany.appLinkAndroid')}}</label>
                <input type="text" name="appLinkAndroid" :placeholder="$t('settingCompany.appLinkAndroid')" v-model="model.app_android" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('settingCompany.appLinkIos')}}</label>
                <input type="text" name="appLinkIos" :placeholder="$t('settingCompany.appLinkIos')" v-model="model.app_ios" class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Componenta extrasa pentru Qr/Kiosk Colors -->
      <!-- <kiosk-colors-card v-model="model" /> -->

    </form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input, Upload, Button, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import {mapFields} from 'vee-validate'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'

  // Import noua componenta
  import KioskColorsCard from 'src/components/UIComponents/KioskColorsCard.vue'

  Vue.component('v-select', vSelect)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      // GeneralTopBar,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select,
      PSwitch,
      KioskColorsCard
    },
    props: {
      defaultData: {},
      modeldata: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata: {
        immediate: true,
        handler (newVal) {
          this.model = newVal || {}
        }
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData
      }
    },
    computed: {
      ...mapFields(['title', 'description'])
    },
    methods: {
      deleteCacheFromKiosk () {
        console.log('deleteCacheFromKiosk')
      },
      restartAllKiosk () {
        console.log('restartAllKiosk')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop][0])
          }
        }
      },
      handleImgChnage (file, fileList, index) {
        const self = this
        let pp = this.model
        const isOkSize = file.size / 1024 / 1024 < 5
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          self.$refs.upload.clearFiles()
          pp.kiosk_transparent_bg = []
        } else {
          if (fileList.length > 1) {
            pp.kiosk_transparent_bg = fileList.slice(1)
          } else {
            pp.kiosk_transparent_bg = fileList
          }
        }
        this.model = null
        this.model = pp
        this.getBase64(this.model.kiosk_transparent_bg[0].raw).then((base64enc) => {
          this.model.kiosk_transparent_bg[0].base64enc = base64enc
        })
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      handleRemove (file, fileList, index) {
        if (fileList.length === 0) {
          this.model.kiosk_transparent_bg = []
        }
      },
      saveDetails () {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'self_order_domain': (this.model.self_order_domain),
          'table_colors': (this.model.table_colors),
          'kiosk_pass': (this.model.kiosk_pass),
          'text_fiscal_print': (this.model.text_fiscal_print),
          'app_link': (this.model.app_link),
          'app_android': (this.model.app_android),
          'app_ios': (this.model.app_ios)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]))
          } else {
            swal({'text': self.$t('settingsTips.tipsSuccess'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/App.vue